import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChainsService } from 'src/app/services/chains.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-my-chains',
  templateUrl: './my-chains.component.html',
  styleUrls: ['./my-chains.component.scss']
})
export class MyChainsDashboardComponent implements OnInit {
  chains: any[] = [];
  loading: boolean = true;

  constructor(
    private chainsService: ChainsService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadMyChains();
  }

  loadMyChains(): void {
    this.spinner.show();
    this.loading = true;
    this.chainsService.getMyChains().subscribe({
      next: (res: any) => {
        const rawChains = res.chains || res.response?.data?.chains || [];
        if (rawChains.length === 0) {
          this.chains = [];
          this.loading = false;
          this.spinner.hide();
          return;
        }
        const storeRequests = rawChains.map((chain: any) =>
          this.chainsService.getChainStores(chain._id).pipe(
            catchError(() => of([]))
          )
        );
        forkJoin(storeRequests).subscribe(
          (storeResults: any) => {
            this.chains = rawChains.map((chain: any, i: number) => ({
              ...chain,
              stores: (storeResults as any[])[i] || []
            }));
            this.loading = false;
            this.spinner.hide();

            if (this.chains.length === 1) {
              this.viewChainOverview(this.chains[0]._id);
            }
          },
          () => {
            this.chains = rawChains.map((chain: any) => ({ ...chain, stores: [] }));
            this.loading = false;
            this.spinner.hide();

            if (this.chains.length === 1) {
              this.viewChainOverview(this.chains[0]._id);
            }
          }
        );
      },
      error: (err: any) => {
        this.loading = false;
        this.spinner.hide();
        Swal.fire('Error', err.error?.response?.message || 'Failed to load chains', 'error');
      }
    });
  }

  manageStore(store: any): void {
    this.router.navigate(['/store', store._id, 'ecommerce'], {
      state: { storeName: store.storeName, storeId: store._id }
    });
  }

  viewChainReports(chainId: string): void {
    this.router.navigate(['/chain-reports', chainId]);
  }

  viewChainOverview(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'overview']);
  }

  viewChainBranding(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'branding']);
  }

  viewChainCatalog(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'catalog']);
  }

  viewChainLoyalty(chainId: string): void {
    this.router.navigate(['/chain', chainId, 'loyalty']);
  }

  getStatusText(status: any): string {
    return status === 1 || status === true ? 'Active' : 'Inactive';
  }

  getStatusBadge(status: any): string {
    return status === 1 || status === true ? 'success' : 'warning';
  }

  getStoreStatusBadge(status: any): string {
    return status === 1 || status === true ? 'success' : 'basic';
  }
}
